module.exports = __webpack_public_path__ + "static/media/theme-landing-1.999c8d3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/theme-landing-1.jpg
// module id = 359
// module chunks = 0